import { render, staticRenderFns } from "./selectCb.vue?vue&type=template&id=39c46e5a&scoped=true"
import script from "./selectCb.vue?vue&type=script&lang=js"
export * from "./selectCb.vue?vue&type=script&lang=js"
import style0 from "./selectCb.vue?vue&type=style&index=0&id=39c46e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c46e5a",
  null
  
)

export default component.exports